import React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "react-error-boundary";
import EmptyStateMessage from "./empty-state-message";
import classNames from "classnames";

const MyFallbackComponent = ({
  componentStack,
  error,
  message = "Oops, there was a problem.",
  icon = "build",
  className,
}) => <EmptyStateMessage className={classNames("et--page-error-boundary", className)} icon={icon} text={message} />;

MyFallbackComponent.propTypes = {
  className: PropTypes.string,
  componentStack: PropTypes.string,
  error: PropTypes.string,
  icon: PropTypes.string,
  message: PropTypes.string,
};

const ETErrorBoundary = ({ message, icon, className, ...props }) => (
  <ErrorBoundary
    FallbackComponent={() => <MyFallbackComponent message={message} icon={icon} className={className} />}
    {...props}
  />
);

ETErrorBoundary.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  message: PropTypes.string,
};

export default ETErrorBoundary;
